// Simply add an anchor to the pagination links of the Vehicle Compatibility list
const setPaginationLinks = function() {
    const links = document.querySelectorAll(".compatibility .page-link");

    links.forEach(el => {
        el.setAttribute('href', el.getAttribute("href") + "#compatibility");
    });
}
setPaginationLinks();
